import Bowser from "bowser";

export const clientEnvIsLinux = () =>
  Bowser.getParser(window.navigator.userAgent).getOSName(true) === "linux";
